import { Impressionable } from '@fiverr-private/futile/lib/element';

const DOMSelector = '.subcat-banner';
const DOMAttribute = 'data-banner-id';
const dataIdentifier = 'banner_id';

export default class SubcategoryImpressionable extends Impressionable {
    constructor(options = {}, enrichData) {
        const basicOptions = {
            DOMSelector,
            DOMAttribute,
            dataIdentifier,
            enrich: (banners) => this.enrich(banners)
        };

        const finalOptions = Object.assign(basicOptions, options);

        super(finalOptions);

        const {
            itemContextType,
            sourcepage,
            pageCtxId,
            subCategoryName,
            carouselPosition
        } = enrichData;

        this.itemContextType = itemContextType;
        this.sourcepage = sourcepage;
        this.pageCtxId = pageCtxId;
        this.subCategoryName = subCategoryName;
        this.carouselPosition = carouselPosition;
    }

    enrich(banner) {
        const {
            $index,
            sub_category
        } = banner;

        return {
            group: 'impression',
            type: 'sub_category_impression',
            item_context: {
                type: this.itemContextType,
                source_page: this.sourcepage,
                position: ($index + 1),
                page_ctx_id: this.pageCtxId
            },
            sub_category: {
                id: sub_category,
                name: this.subCategoryName
            },
            listings: {
                carousel_position: this.carouselPosition
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/common/HomePage/SubcategoryBanners/SubcategoryImpressionable.js